<!-- Checkbox -->
<!-- //NOSONAR --><div (click)="toggleSelect()" class="matCheckBtn">
    <!-- //NOSONAR --><mat-checkbox [(ngModel)]="isChecked" [matMenuTriggerFor]="appMenu" [disableRipple]="true" (click)="$event.preventDefault()">
    </mat-checkbox>
</div>


<!-- Options for select and unselect -->
<mat-menu #appMenu="matMenu">
    <ul class="mdc-list demo-list ul-mat-menu">
        <!-- //NOSONAR --><li placement="top" class="mdc-list-item mdc-ripple-upgraded context-menu-heigth li-font" (click)="selectAllDataAGGrid(true)">
            <span
                class="mdc-fab__icon material-icons context-menu-font-size ey-dna-icon-select-all-page iconSpan"></span>&nbsp;&nbsp;<span
                class="txt-span cog-text">
              CASE_SELECTALL
            </span>
        </li>
        <!-- //NOSONAR --><li *ngIf="selectedNodesLength > 0" class="mdc-list-item mdc-ripple-upgraded context-menu-heigth li-font" (click)="selectAllDataAGGrid(false)">
            <span
                class="mdc-fab__icon material-icons context-menu-font-size ey-dna-icon-unselect-all-page iconSpan"></span>&nbsp;&nbsp;<span
                class="txt-span cog-text">
               CASE_UNSELECTALL               
            </span>
        </li>
    </ul>
</mat-menu>